<template>
    <div>
        <v-server-table id="relation-log-table" :url="apiUrl" :columns="columns" :options="options" class="trigger" ref="table">
            <template slot="filter__backoffice">
                <div class="place-center">
                    <label class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input"
                               v-model="filterEnabled.backoffice"
                               @change="refreshTable('backoffice')">
                        <span class="custom-control-indicator"></span>
                    </label>
                </div>
            </template>
            <template slot="filter__trajectory_manager">
                <div class="place-center">
                    <label class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input"
                               v-model="filterEnabled.trajectory_manager"
                               @change="refreshTable('trajectory_manager')">
                        <span class="custom-control-indicator"></span>
                    </label>
                </div>
            </template>
            <template slot="filter__candidate">
                <div class="place-center">
                    <label class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input"
                               v-model="filterEnabled.candidate"
                               @change="refreshTable('candidate')">
                        <span class="custom-control-indicator"></span>
                    </label>
                </div>
            </template>
            <template slot="filter__employer">
                <div class="place-center">
                    <label class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input"
                               v-model="filterEnabled.employer"
                               @change="refreshTable('employer')">
                        <span class="custom-control-indicator"></span>
                    </label>
                </div>
            </template>
            <template slot="backoffice" slot-scope="{ row }">
                <div class="place-center">
                    <span v-if="!usesNewPermissionSystem(row)">-</span>
                    <span v-else>
                    <i v-if="canSee(row, 'backoffice')" class="fa fa-check green"/>
                    <i v-else class="fa fa-times red"></i>
                </span>
                </div>
            </template>
            <template slot="trajectory_manager" slot-scope="{ row }">
                <div class="place-center">
                    <span v-if="!usesNewPermissionSystem(row)">-</span>
                    <span v-else>
                    <i v-if="canSee(row, 'trajectory_manager')" class="fa fa-check green"/>
                    <i v-else class="fa fa-times red"></i>
                </span>
                </div>
            </template>
            <template slot="candidate" slot-scope="{ row }">
                <div class="place-center">
                    <span v-if="!usesNewPermissionSystem(row)">-</span>
                    <span v-else>
                    <i v-if="canSee(row, 'candidate')" class="fa fa-check green"/>
                    <i v-else class="fa fa-times red"></i>
                </span>
                </div>
            </template>
            <template slot="employer" slot-scope="{ row }">
                <div class="place-center">
                    <span v-if="!usesNewPermissionSystem(row)">-</span>
                    <span v-else>
                    <i v-if="canSee(row, 'employer')" class="fa fa-check green"/>
                    <i v-else class="fa fa-times red"></i>
                </span>
                </div>
            </template>
            <template slot="action_date" slot-scope="{ row }">
                <span>{{ row.action_date | date }}</span>
            </template>
            <template slot="created_at" slot-scope="{ row }">
                <span>{{ row.created_at | date }}</span>
            </template>
            <template slot="author" slot-scope="{ row }">
                <span>{{ row.author_name }}</span>
            </template>
            <template slot="log" slot-scope="{ row }">
                <b><a
                    v-if="row.subject && ($can('view-intern-logs') || $can('view-report-logs') || $can('view-candidate-logs'))"
                    href="#"
                    @click.prevent="showLogInfo(row)"
                >{{ row.subject }}</a></b><br>
                <span
                    v-if="row.body && ($can('view-intern-logs') || $can('view-report-logs') || $can('view-candidate-logs'))"
                    href="#"
                    @click.prevent="showLogInfo(row)"
                    v-html="formatBody(row.body)"></span>
            </template>
            <template slot="reminder" slot-scope="{ row }">
                <span>{{ row.reminder | date }}</span>
            </template>
            <!-- // DELETE ID-325 
            <template slot="total_duration" slot-scope="{ row }">
                <span>{{ row.total_duration | duration }}</span>
            </template>
             -->
        </v-server-table>
        <portal to="modals" v-if="showLog">
            <b-modal
                    v-model="showLog"
                    :hideFooter="true"
                    :title="openLog.category"
                    size="lg"
            >
                <h5>{{ openLog.subject }}</h5>
                <nl2br tag="p" :text="openLog.body" />
            </b-modal>
        </portal>
    </div>
</template>

<script>
import {Event} from 'vue-tables-2';
import {Actions} from '~/components/tables/logs'
import {TableMixin} from '~/mixins/table'
import {Event as VueTableEvent} from 'vue-tables-2';
import Modal from "bootstrap-vue/lib/components/modal";

export default {
    name: 'logsTable',
    components: {Modal},
    mixins: [TableMixin],

    props: {
        apiUrl: {
            type: String,
            default: route('logs.table'),
        },
        columns: {
            type: Array,
            default: () => [
                'backoffice',
                'trajectory_manager',
                'candidate',
                'employer',
                'action_date',
                'created_at',
                'author',
                'log',
                'reminder',
                // DELETE ID-325 'total_duration',
                'actions',
            ],
        },
        filterable: {
            type: Array,
            default: () => [],
        },
        forceRefresh: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            hasTouched: false,
            templates: {
                actions: Actions,
            },
            filterEnabled: {
                backoffice: false,
                trajectory_manager: false,
                candidate: false,
                employer: false
            },
            options: {
                headings: {
                    action_date: this.uLang('app.action_date'),
                    backoffice: this.uLang('app.backoffice').charAt(0),
                    trajectory_manager: this.uLang('app.trajectory_manager').charAt(0),
                    candidate: this.uLang('app.candidate').charAt(0),
                    employer: this.uLang('app.employer').charAt(0),
                    created_at: this.uLang('app.created_at'),
                    author: this.uLang('app.author'),
                    log: this.uLang('app.log'),
                    reminder: this.uLang('app.reminder'),
                    // DELETE ID-325 total_duration: this.uLang('app.total_duration'),
                    actions: this.uLang('app.actions'),
                },
                headingsTooltips: {
                    backoffice: this.uLang('app.backoffice'),
                    trajectory_manager: this.uLang('app.trajectory_manager'),
                    candidate: this.uLang('app.candidate'),
                    employer: this.uLang('app.employer')
                },
                sortable: [
                    // TODO: Temporarily disabled until green light has been given on hours for a fix
                    // 'created_at',
                    // 'action_date',
                    // 'reminder'
                ],
                customFilters: [
                    'backoffice',
                    'trajectory_manager',
                    'candidate',
                    'employer'
                ]
            },
            openLog: null,
            showLog: false
        }
    },

    mounted() {
        this.$watch(
            () => {
                return this.$refs.table.data;
            },
            () => {
                if (this.$route.query.logitem) {
                    this.showLogInfo(this.$refs.table.data.filter(log => {
                        return log.id == this.$route.query.logitem
                    })[0])
                }
            }
        )
    },

    watch: {
        forceRefresh() {
            if (this.forceRefresh == true) {
                this.$refs.table.refresh()
                this.$emit('refreshed')
            }
        }
    },

    methods: {
        formatBody(body) {
            return body ? body.replace(/\n/g, '<br>') : '';
        },
        showLogInfo(log) {
            let route = this.$router.resolve({
                name: "admin.relations.logs.show", params: {
                    relationId: log.entity_id, logId: log.id,
                }
            })
            window.open(route.href);
        },
        canSee(log, type) {
            return !!+JSON.parse(log.who_can_see)[type]
        },
        usesNewPermissionSystem(log) {
            return log.who_can_see_logs_id !== null
        },
        refreshTable(name, query) {
            Event.$emit('vue-tables.filter::' + name, this.filterEnabled[name])
        }
    },

    filters: {
        duration(value) {
        const num = parseFloat(value);
        if (isNaN(num)) return '';

        const hours = Math.floor(value);
        const minutes = Math.round((value - hours) * 60);

        let result = '';
        if (hours > 0) result += `${hours} u`;
        if (minutes > 0) result += ` ${minutes} m`;

        return result.trim();
        }
    }
}
</script>

<style>
#relation-log-table table tbody td{
    align-content: flex-start;
}
</style>
<style lang="scss" scoped>
.grey-icon {
    color: #5c5c5c;
}

.green {
    color: green;
}

.red {
    color: red;
}

.place-center {
    text-align: center;
    width: 100%;
}

.custom-control {
    // Override margin right to center the checkboxes
    margin-right: -0.5rem;
}
</style>
